// extracted by mini-css-extract-plugin
module.exports = {"congratsMessage":"styles_congratsMessage__2B1fS","serviceVoucher":"styles_serviceVoucher__WwsqF"};